import { FC } from "react";
import { Stack } from "@chakra-ui/react";
import { DocumentsPageDocumentItem } from "./DocumentsPageDocumentItem.tsx";

import { useGetDocumentsQuery } from "../../../../api/documents";
import { DocumentsPageContentError } from "./DocumentsPageContentError";
import { DocumentsPageContentEmpty } from "./DocumentsPageContentEmpty";
import { DocumentsPageContentPending } from "./DocumentsPageContentPending";

export const DocumentsPageContent: FC = () => {
  const { data, isPending, isError } = useGetDocumentsQuery();

  if (isPending) {
    return <DocumentsPageContentPending />;
  }

  if (isError || !Array.isArray(data)) {
    return <DocumentsPageContentError />;
  }

  if (data.length === 0) {
    return <DocumentsPageContentEmpty />;
  }

  return (
    <Stack pt="25px" spacing={0}>
      {data.map((document, index) => (
        <DocumentsPageDocumentItem key={index} document={document} />
      ))}
    </Stack>
  );
};
